// src/api/axiosInstance.ts
import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://localhost:7126/api", // 👉 kendi API adresini gerektiğinde değiştir
  // baseURL: "https://karaliseledosemeapi.muzayedeexpress.com/api",
  baseURL: "https://yildizhobieviapi.muzayedeexpress.com/api",
  // baseURL: "https://api.picardchu.com/api",
  // baseURL: "https://portakal3dapi.muzayedeexpress.com/api",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

/* ────────────────────────────────────────────────
   🔐 Request Interceptor: Token ekleme
   Öncelik sırası:
   1️⃣ admin_token
   2️⃣ cust_token
──────────────────────────────────────────────── */
axiosInstance.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("admin_token");
  const custToken = localStorage.getItem("cust_token");
  const token = adminToken || custToken;

  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }

  return config;
});

/* ────────────────────────────────────────────────
   🔁 Global Response Error Handling
──────────────────────────────────────────────── */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error?.response || error?.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
